<script>
import { StyledDropdown } from '../../../components/dropdown'
import MemberBlockYears from './MemberBlockYears'

export default {
  name: 'MemberBlock',

  components: {
    MemberBlockYears
  },

  props: {
    index: {
      type: Number,
      default: 0
    },

    block: {
      type: Object,
      default: () => {}
    },

    remainingYears: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      usedYears: this.block.usedYears,
      isExistingMember: null
    }
  },

  updated() {
    this.$el.querySelectorAll('input.membership-field, select.membership-field').forEach($el => {
      if ($el.name.indexOf('$') !== -1) {
        $el.name = $el.name.replace('$', this.index)
      }
    })

    this.$el.querySelectorAll('[required]').forEach($el => {
      const $fieldLabel = $el.closest('.field').querySelector('label')
      if ($fieldLabel.innerHTML.indexOf('<sup>') === -1) {
        $fieldLabel.innerHTML = `${$fieldLabel.textContent} <sup>*</sup>`
      }
    })

    this.$el.querySelectorAll('select').forEach($el => StyledDropdown.init($el))
  },

  methods: {
    updateIsExistingMember(e) {
      this.isExistingMember = (e.target.value == true)
    },

    handleRadioLabelClick(e) {
      e.target.closest('li').querySelector('input').click()
    },

    increaseYears() {
      this.usedYears = this.usedYears + 1

      this.$root.$emit('increase-years')
    },

    decreaseYears() {
      this.usedYears = this.usedYears - 1

      this.$root.$emit('decrease-years')
    }
  },

  template: '#member-block-template'
}
</script>
